import { render, staticRenderFns } from "./founderStageOne.vue?vue&type=template&id=67084fbe"
import script from "./founderStageOne.vue?vue&type=script&lang=js"
export * from "./founderStageOne.vue?vue&type=script&lang=js"
import style0 from "./founderStageOne.vue?vue&type=style&index=0&id=67084fbe&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports